var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4996 22.0006H22.7096L22.4296 21.7306C23.6296 20.3306 24.2496 18.4206 23.9096 16.3906C23.4396 13.6106 21.1196 11.3906 18.3196 11.0506C14.0896 10.5306 10.5296 14.0906 11.0496 18.3206C11.3896 21.1206 13.6096 23.4406 16.3896 23.9106C18.4196 24.2506 20.3296 23.6306 21.7296 22.4306L21.9996 22.7106V23.5006L26.2496 27.7506C26.6596 28.1606 27.3296 28.1606 27.7396 27.7506C28.1496 27.3406 28.1496 26.6706 27.7396 26.2606L23.4996 22.0006ZM17.4996 22.0006C15.0096 22.0006 12.9996 19.9906 12.9996 17.5006C12.9996 15.0106 15.0096 13.0006 17.4996 13.0006C19.9896 13.0006 21.9996 15.0106 21.9996 17.5006C21.9996 19.9906 19.9896 22.0006 17.4996 22.0006Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.faedae83.svg";
export { ForwardRef as ReactComponent };